import gql from 'graphql-tag';

export const UpdateBabyByIdQuery = gql`
  mutation UpdateBabyById(
    $id: uuid!
    $dob: date!
    $gender: private_gender_enum!
    $name: String!
    $delivery: private_baby_delivery_mode_enum!
    $preterm: Boolean!
  ) {
    update_baby_by_pk(
      pk_columns: { id: $id }
      _set: {
        dob: $dob
        gender: $gender
        name: $name
        delivery: $delivery
        preterm: $preterm
      }
    ) {
      id
      name
      dob
      gender
    }
  }
`;
